/*eslint-disable*/
import { getHigherUnitAndQuantity } from '@/Helpers';
export const tableCellConfig = {
	order: {
		STORE_QTY: {
			render: ({ value, unit, onChange, viewMode }) => (
				<div className='flex items-center gap-1'>
					<input
						type='number'
						className='text-center w-[50px] border border-gray-300 focus:border-blue-500 outline-none transition-colors duration-200'
						style={{
							borderRadius: '4px',
							padding: '2px 6px',
						}}
						value={value ?? ''}
						disabled={viewMode}
						onChange={(e) => onChange(e.target.value)}
						onKeyDown={(e) =>
							['-', '+', "'", 'e', 'E'].includes(e.key) &&
							e.preventDefault()
						}
					/>
					<span className='text-[11px] text-gray-500'>{unit}</span>
				</div>
			),
		},
	},
	orderWise: {
		STORE_QTY: {
			render: ({ value, unit, onChange, viewMode }) => (
				<div className='flex items-center gap-1'>
					<input
						type='number'
						className='text-center w-[50px] border border-gray-300 focus:border-blue-500 outline-none transition-colors duration-200'
						style={{
							borderRadius: '4px',
							padding: '2px 6px',
						}}
						value={value ?? ''}
						disabled={viewMode}
						onChange={(e) => onChange(e.target.value)}
						onKeyDown={(e) =>
							['-', '+', "'", 'e', 'E'].includes(e.key) &&
							e.preventDefault()
						}
					/>
					<span className='text-[11px] text-gray-500'>{unit}</span>
				</div>
			),
		},
	},
	dataEntry: {
		STORE_QTY: {
			render: ({
				value,
				unit,
				onChange,
				rowData,
				viewMode,
				header,
				noOrder,
			}) => {
				if (noOrder) {
					return (
						<div className='flex items-center justify-center text-[11px] text-gray-400 italic'>
							Order not placed
						</div>
					);
				}
				const orderedQty =
					parseFloat(rowData[header.id]?.orderedQty) || 0;
				const currentValue = parseFloat(value) || 0;
				const isExceedingOrder = currentValue > orderedQty;

				const handleChange = (e) => {
					const newValue = e.target.value;
					const parsedValue = parseFloat(newValue);
					if (
						newValue === '' ||
						isNaN(parsedValue) ||
						parsedValue <= orderedQty
					) {
						onChange(newValue);
					}
				};

				return (
					<div className='flex items-center gap-1'>
						<input
							type='number'
							className={`text-center w-[50px] border outline-none transition-colors duration-200 ${
								isExceedingOrder
									? 'border-orange-500 bg-orange-50'
									: 'border-gray-300 focus:border-blue-500'
							}`}
							style={{
								borderRadius: '4px',
								padding: '2px 6px',
							}}
							value={value ?? ''}
							disabled={viewMode}
							max={orderedQty}
							onChange={handleChange}
							onKeyDown={(e) =>
								['-', '+', "'", 'e', 'E'].includes(e.key) &&
								e.preventDefault()
							}
						/>
						<span className='text-[11px] text-gray-500'>
							{unit}
						</span>
						/{' '}
						<span className='text-center text-[12px]'>
							{rowData[header.id]?.orderedQty}
						</span>
						<span className='text-center text-[12px]'> {unit}</span>
					</div>
				);
			},
		},
	},
	buyerOrder: {
		STORE_QTY: {
			render: ({ value, unit, onChange, viewMode }) => (
				<div className='flex items-center gap-1'>
					<input
						type='number'
						className='text-center w-[50px] border border-gray-300 focus:border-blue-500 outline-none transition-colors duration-200'
						style={{
							borderRadius: '4px',
							padding: '2px 6px',
						}}
						value={value ?? ''}
						disabled={viewMode}
						onChange={(e) => onChange(e.target.value)}
						onKeyDown={(e) =>
							['-', '+', "'", 'e', 'E'].includes(e.key) &&
							e.preventDefault()
						}
					/>
					<span className='text-[11px] text-gray-500'>{unit}</span>
				</div>
			),
		},
	},
};
